import React from "react";

import { ReactComponent as StatusBarChecked } from 'Icons/statusbarChecked.1.svg';


const TripStatusBar = ({className, rfqType}) => {
    return (
        <div className={"col-1 " + (className || "")}>
            <div className="col-1 row-100 flex flex-middle flex-between">
                <div className="flex flex-middle pl-10 pr-10">
                    <div className="bg-theme fs-12 fBold white-color ht-20 wt-20 br-20 flex flex-center flex-middle">
                        1
                    </div>
                    <div className="ml-10">
                        <div className="fs-14 fBold header-dark-color mb-2">Vehicle Details</div>
                    </div>
                </div>
                <div className="flex-1 border-status-bar"></div>
                <div className="flex flex-middle pl-10 pr-10">
                    <div className="bg-theme fs-12 fBold white-color ht-20 wt-20 br-20 flex flex-center flex-middle">
                        2
                    </div>
                    <div className="ml-10">
                        <div className="fs-14 fBold header-dark-color mb-2">Stops</div>
                    </div>
                </div>

                {rfqType ===2 && <div className="flex-1 border-status-bar"></div>}
                {rfqType ===2 && <div className="flex flex-middle pl-10 pr-10">
                    <div className="bg-theme fs-12 fBold white-color ht-20 wt-20 br-20 flex flex-center flex-middle">
                        3
                    </div>
                    <div className="ml-10">
                        <div className="fs-14 fBold header-dark-color mb-2">Costs</div>
                    </div>
                </div>}

                <div className="flex-1 border-status-bar"></div>
                <div className="flex flex-middle pl-10 pr-10">
                    <div className="bg-theme fs-12 fBold white-color ht-20 wt-20 br-20 flex flex-center flex-middle">
                        {rfqType === 1?3:4}
                    </div>
                    <div className="ml-10">
                        <div className="fs-14 fBold header-dark-color mb-2">Bidding And Payments</div>
                    </div>
                </div>
                
            </div>
        </div>
    );
};

export default TripStatusBar;